module.exports = "<p>\r\n  jewellery-fair works!\r\n</p>\r\n"